import { Feature } from "ol";
import Geometry from "ol/geom/Geometry";
import { RouteSegmentsCsvModel } from "./routeSegmentsCSV";
import { RouteRowInfo } from "./RouteTypeList";

export class RouteSegmentsXMLModel{
    layerName : string;
    lineWeight : number = 2;
    lineColor : string = '#0000FF';
    lineColorNullVal : string = '#FF0000';
    features: Feature<Geometry>[] = [];
    file : File;

    routeSegments: RouteRowInfo[] = [];

    saveData(): RouteSegmentsCsvModel{
        let newModel : RouteSegmentsCsvModel = new RouteSegmentsCsvModel();
        newModel.dataStartingLine = null;
        newModel.fieldSeparator = null;
        newModel.decimalSeparator = null;
        newModel.layerName = this.layerName;
        newModel.lineWeight = this.lineWeight;
        newModel.lineColor = this.lineColor;
        newModel.lineColorNullVal = this.lineColorNullVal;
        newModel.features = this.features;
        return newModel;
      }
}